module.exports = __webpack_public_path__ + "media/images/ampacity2-8502321afbec65b39fcc1d87ba152cfe.png";